import { useMessagesRapides, useModelesEmail, useModelesWhatsapp } from '../api/useComposeur';
import { echecSansDonnee } from '../helpers/requete';
import type { CleCanal } from '../config/canaux';

interface UseSourcesComposeurParams {
    /** L'hôtel d'envoi ; `null` tant qu'il reste à choisir : rien n'est chargé. */
    facilityId: number | null;
    canal: CleCanal | null;
    rapidesOuverts: boolean;
    modelesOuverts: boolean;
    modelesEmailOuverts: boolean;
}

/**
 * Les contenus proposés par le composeur, pour l'hôtel d'envoi — sorti de
 * `Composeur.tsx` pour le garder lisible.
 *
 * Toujours chargés À L'OUVERTURE de leur feuille, jamais avant (#31). react-query 3 :
 * « Réessayer » après un échec ne repasse pas isLoading, seulement isFetching.
 */
export function useSourcesComposeur({
    facilityId,
    canal,
    rapidesOuverts,
    modelesOuverts,
    modelesEmailOuverts,
}: UseSourcesComposeurParams) {
    const rapides = useMessagesRapides(facilityId, rapidesOuverts, canal ?? undefined);
    const modeles = useModelesWhatsapp(facilityId, modelesOuverts || canal === 'whatsapp');
    const modelesEmail = useModelesEmail(facilityId, modelesEmailOuverts);

    const modelesEnEchec = echecSansDonnee(modeles);
    const modelesEmailEnEchec = echecSansDonnee(modelesEmail);

    return {
        rapides,
        modeles,
        modelesEmail,
        modelesEnEchec,
        modelesEnChargement: modeles.isLoading || (modelesEnEchec && modeles.isFetching),
        modelesEmailEnEchec,
        modelesEmailEnChargement: modelesEmail.isLoading || (modelesEmailEnEchec && modelesEmail.isFetching),
    };
}
